export const INVESTMENTS_QUOTE_POLL_MS = 60_000;
export const INVESTMENTS_PORTFOLIO_POSITION_LIMIT = 10;
export const INVESTMENTS_WATCHLIST_TICKER_LIMIT = INVESTMENTS_PORTFOLIO_POSITION_LIMIT;
export const DASHBOARD_PAGE_SIZE_OPTIONS = [10, 25, 50] as const;
export const DASHBOARD_PAGE_SIZE = DASHBOARD_PAGE_SIZE_OPTIONS[0];
export const DASHBOARD_PAGE_WINDOW = 7;
